import React from "react";
import StakeHolderDeputadoProfile from "./StakeholderDeputadoProfile";
import StakeHolderMinistroProfile from "./StakeholderMinistroProfile";

export const StakeholderProfileContext = React.createContext({});

export default function StakeHolderProfile({ match: { params } }) {
  if (params.id.substring(0,8) === "minister") return <StakeHolderMinistroProfile params={params} />;
  return <StakeHolderDeputadoProfile params={params} />;
}